import type { ApiFetchGiratudoLeaderboardPort } from '~/handlers/ports/api-fetch-giratudo-leaderboard.port';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';
import { getApostatudoAuthHeaders } from '~/utils/apostatudo/get-apostatudo-auth-headers';

export class ApostatudoApiFetchGiratudoLeaderboardAdapter
  implements ApiFetchGiratudoLeaderboardPort
{
  async handle(userId?: number, page = 1, perPage = 10) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    const params = new URLSearchParams();

    if (userId) params.append('user_id', userId.toString());
    params.append('page', page.toString());
    params.append('per_page', perPage.toString());

    const response = await fetch(
      `${getApostatudoApiUrl()}/hourly-raffle/leaderboard?${params.toString()}`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          ...getApostatudoAuthHeaders(),
        },
        signal: controller.signal,
      },
    ).finally(() => clearTimeout(timeoutId));

    if (!response.ok) {
      throw new Error(`Failed to fetch leaderboard: ${response.status}`);
    }

    const data = await response.json();

    const userPos = data.user_position ?? data.userPosition;

    return {
      data: data.data.map((entry: any) => ({
        position: entry.position,
        username: entry.username,
        ticketNumber: entry.ticket_number ?? entry.ticketNumber,
        prize: entry.prize,
        createdAt: entry.created_at ?? entry.createdAt,
      })),
      currentPage: data.current_page ?? data.currentPage,
      totalPages: data.total_pages ?? data.totalPages,
      userPosition: userPos
        ? {
            position: userPos.position,
            username: userPos.username,
            ticketNumber: userPos.ticket_number ?? userPos.ticketNumber,
            prize: userPos.prize,
            createdAt: userPos.created_at ?? userPos.createdAt,
          }
        : null,
    };
  }
}
